import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export interface InvoiceRequestRow {
  id: string;
  source?: {
    car?: {
      licence?: string;
      label?: string;
    };
  };
  in_out_storage?: string;
  pickup_and_delivery_date?: string;
  tireset_cleaning?: boolean;
}

interface InvoiceRequestsTableProps {
  requests: InvoiceRequestRow[];
  relation?: { id: string; label: string; invoice_cleaning?: boolean };
}

export const InvoiceRequestsTable = ({
  requests,
  relation,
}: InvoiceRequestsTableProps) => {
  const { t } = useTranslation("common");
  const showCleaning = relation?.invoice_cleaning;
  return (
    <div className="table-responsive">
      <table className="table crud-table align-middle">
        <thead>
          <tr>
            <th className="py-2 text-nowrap">{t("Licence plate")}</th>
            <th className="py-2 text-nowrap">{t("Date in/out storage")}</th>
            {showCleaning && (
              <th className="py-2 text-nowrap">{t("Cleaning")}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {requests.map((req: InvoiceRequestRow) => {
            const plate = new LicensePlate(req.source?.car?.licence ?? "");
            return (
              <tr key={req.id}>
                <td>
                  <Link
                    to={"/requests/" + req.id}
                    className={"no-link-decoration"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className={"tireset-table-licence-plate me-2"}
                      style={{
                        background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
                      }}
                    >
                      <div>
                        {plate.valid()
                          ? plate.pretty()
                          : req.source?.car?.label}
                      </div>
                    </div>
                  </Link>
                </td>
                <td>
                  {(() => {
                    const dateStr =
                      req.in_out_storage || req.pickup_and_delivery_date;
                    return dateStr
                      ? new Intl.DateTimeFormat("nl-NL").format(
                          new Date(dateStr),
                        )
                      : "";
                  })()}
                </td>
                {showCleaning && (
                  <td>
                    {req.tireset_cleaning ? t("Included") : t("Excluded")}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
